import { createSelector } from '@reduxjs/toolkit';
import { selectActivityContentLocale, selectActivityFromContentDetailState } from 'component/page/detail/store/detail.selectors';
import { selectCmsFromBootstrap, selectIsBotOrIsPrerenderFromBootstrap } from 'store/slice/bootstrap';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { Breakpoint, selectBreakpoint } from 'store/slice/screen';
import { ActivitySummary } from 'gql/autogen/ActivitySummary';

interface OwnProps {
    isDisplayFullContent?: boolean;
}
interface StateProps {
    cms: CmsValue;
    activity: ActivitySummary;
    contentLocale: string;
    breakpoint: Breakpoint;
    isBotOrIsPrerender: boolean;
}

export type ActivityOverviewProps = OwnProps & StateProps;

export const mapStateToProps = createSelector(
    selectCmsFromBootstrap,
    selectActivityFromContentDetailState,
    selectActivityContentLocale,
    selectBreakpoint,
    selectIsBotOrIsPrerenderFromBootstrap,
    (cms, activity, contentLocale, breakpoint, isBotOrIsPrerender) => {
        return {
            cms,
            activity: activity || {},
            contentLocale,
            breakpoint,
            isBotOrIsPrerender,
        };
    },
);
